(function () {
  const SELECTOR = '[data-sibling-swapper]';
  const SECTION_PREFIX = 'shopify-section-';

  const SECTION_IDS = [
    'main-product',
    'breadcrumbs',
    'product-recommendations',
    '17765181992382ada1'
  ];

  const cache = new Map();

  function activeSectionIds() {
    return SECTION_IDS.filter(function (id) {
      return document.getElementById(SECTION_PREFIX + id);
    });
  }

  function buildUrl(href, sectionIds) {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('sections', sectionIds.join(','));
    return url.toString();
  }

  function prefetch(href, sectionIds) {
    if (cache.has(href)) return cache.get(href);
    const promise = fetch(buildUrl(href, sectionIds), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Sibling fetch failed: ' + res.status);
        return res.json();
      })
      .catch(function (err) {
        cache.delete(href);
        throw err;
      });
    cache.set(href, promise);
    return promise;
  }

  function updateMeta(href) {
    const mainSection = document.getElementById(SECTION_PREFIX + 'main-product');
    if (mainSection) {
      const heading = mainSection.querySelector('.product-information h1, h1.product-title, h1');
      if (heading) document.title = heading.textContent.trim();
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', new URL(href, window.location.origin).toString());
  }

  function reinitThirdParty() {
    if (window.Shopify && window.Shopify.PaymentButton) {
      try { window.Shopify.PaymentButton.init(); } catch (e) {}
    }
    if (window.jdgm && typeof window.jdgm.refreshAll === 'function') {
      try { window.jdgm.refreshAll(); } catch (e) {}
    }
  }

  function buildProductViewedPayload() {
    const wrapper = document.querySelector('.thb-product-detail');
    if (!wrapper) return null;

    const productId = wrapper.getAttribute('data-product-id');
    const variantId = wrapper.getAttribute('data-variant-id');
    if (!productId || !variantId) return null;

    const ldEl = wrapper.querySelector('script[type="application/ld+json"]');
    if (!ldEl) return null;

    let ld;
    try { ld = JSON.parse(ldEl.textContent); } catch (e) { return null; }

    const selectedOffer = (ld.offers || []).find(function (offer) {
      return offer.url && offer.url.indexOf('variant=' + variantId) !== -1;
    }) || (ld.offers || [])[0] || {};

    const image = Array.isArray(ld.image) ? ld.image[0] : ld.image;

    return {
      productVariant: {
        id: 'gid://shopify/ProductVariant/' + variantId,
        title: selectedOffer.name || ld.name,
        untranslatedTitle: selectedOffer.name || ld.name,
        sku: selectedOffer.sku || '',
        price: {
          amount: parseFloat(selectedOffer.price) || 0,
          currencyCode: selectedOffer.priceCurrency || 'EUR'
        },
        image: image ? { src: image } : undefined,
        product: {
          id: 'gid://shopify/Product/' + productId,
          title: ld.name,
          untranslatedTitle: ld.name,
          vendor: (ld.brand && ld.brand.name) || '',
          type: ld.category || '',
          url: ld.url || window.location.pathname
        }
      }
    };
  }

  function publishProductViewed() {
    const payload = buildProductViewedPayload();
    if (!payload) return;

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish('product_viewed', payload); } catch (e) {}
    }

    window.dispatchEvent(new CustomEvent('sibling-swap:product-viewed', {
      detail: payload
    }));
  }

  function applySwap(sectionsHtml, href) {
    Object.keys(sectionsHtml).forEach(function (id) {
      const el = document.getElementById(SECTION_PREFIX + id);
      if (!el) return;
      el.innerHTML = sectionsHtml[id];

      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: id, load: true }
      }));
    });

    window.history.pushState({ siblingSwap: true }, '', href);
    updateMeta(href);
    reinitThirdParty();
    publishProductViewed();

    document.dispatchEvent(new CustomEvent('sibling:swapped', {
      bubbles: true,
      detail: { url: href }
    }));
  }

  function handleSwap(link) {
    const href = link.getAttribute('href');
    if (!href || href === window.location.pathname) return;

    const ids = activeSectionIds();
    if (ids.length === 0) {
      window.location.href = href;
      return;
    }

    prefetch(href, ids)
      .then(function (sections) { applySwap(sections, href); })
      .catch(function () { window.location.href = href; });
  }

  function onPointerDown(e) {
    const link = e.target.closest(SELECTOR);
    if (!link) return;
    const ids = activeSectionIds();
    if (ids.length === 0) return;
    const href = link.getAttribute('href');
    if (!href) return;
    prefetch(href, ids).catch(function () {});
  }

  function onClick(e) {
    const link = e.target.closest(SELECTOR);
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    handleSwap(link);
  }

  function onPopState() {
    cache.clear();
    window.location.reload();
  }

  document.addEventListener('mousedown', onPointerDown);
  document.addEventListener('touchstart', onPointerDown, { passive: true });
  document.addEventListener('click', onClick);
  window.addEventListener('popstate', onPopState);
})();
